export const WA_CCRS_ENVIRONMENTS = ['UAT', 'Production']

export const isAssignedShopInWashington = (shop) => {
  if (!shop) return false
  const state = (shop.address && shop.address.state) || shop.stateCode || shop.state || ''
  return String(state).toUpperCase() === 'WA'
}

export const shouldShowWaCcrsTab = (shop, flagEnabled) =>
  Boolean(flagEnabled) && isAssignedShopInWashington(shop)

export const normalizeWaCcrsAccounts = (response) => {
  const accounts = Array.isArray(response) ? response : response ? [response] : []
  return accounts
    .filter(Boolean)
    .map(
      ({
        waCcrsClientId,
        waCcrsClientSecret,
        waCcrsClientIdCiphertext,
        waCcrsClientSecretCiphertext,
        ...account
      }) => account,
    )
}

export const normalizeWaCcrsAccount = (response, assignedShopId) =>
  normalizeWaCcrsAccounts(response).find((account) => account.shopId === assignedShopId) || {}

export const serializeWaCcrsRequest = (account = {}, credentials = {}) => {
  const payload = {
    ...(account.id ? { id: account.id } : {}),
    ...(account.companyId ? { companyId: account.companyId } : {}),
    shopId: account.shopId,
    complianceType: 'WA_CCRS',
    stateCode: 'WA',
    environment: account.environment,
    enabled: Boolean(account.enabled),
    enableSync: Boolean(account.enabled && account.enableSync),
    enableDelivery: Boolean(account.enabled && account.enableDelivery),
  }
  const clientId = String(credentials.clientId || '').trim()
  const clientSecret = String(credentials.clientSecret || '').trim()
  if (clientId || clientSecret) {
    payload.waCcrsClientId = clientId
    payload.waCcrsClientSecret = clientSecret
  }
  return payload
}

export const validateWaCcrsForm = (form = {}, credentials = {}, persistedAccount = null) => {
  const errors = {}
  if (!form.environment) errors.environment = 'Environment is required.'
  const clientId = String(credentials.clientId || '').trim()
  const clientSecret = String(credentials.clientSecret || '').trim()
  if (Boolean(clientId) !== Boolean(clientSecret)) {
    errors.credentials = 'Enter both the Client ID and Client Secret.'
  } else if (!clientId && !clientSecret) {
    const savedCredentials = Boolean(
      persistedAccount &&
        persistedAccount.waCcrsClientIdConfigured &&
        persistedAccount.waCcrsClientSecretConfigured &&
        persistedAccount.environment === form.environment,
    )
    if (!savedCredentials) errors.credentials = 'Enter both the Client ID and Client Secret.'
  }
  return errors
}

export const getWaCcrsProviderErrorMessage = (error = {}) => {
  const data = (error.response && error.response.data) || error.data || error
  if (typeof data.errorMessage === 'string' && data.errorMessage.trim())
    return data.errorMessage.trim()
  if (typeof data.message === 'string' && data.message.trim()) return data.message.trim()
  if (error.code === 'ECONNABORTED')
    return 'WA CCRS could not be reached. Your configuration was not changed.'
  return 'WA CCRS could not verify this configuration. Try again or contact support.'
}



// WEBPACK FOOTER //
// ./src/utils/waCcrsCompliance.js